// actions/insights/sales/productsInsightsReport/productsInsightsReportConverter.ts

import type { ProductsInsightsReportDto } from './ProductsInsightsReportDto';
import type { ProductsInsightsReport } from 'model/ProductsInsightsReport';

const n = (v: any) => Number(v ?? 0);

export const convertToProductsInsightsReport = (dto: ProductsInsightsReportDto): ProductsInsightsReport => {
    return {
        range: {
            start: dto?.range?.start ?? '',
            end: dto?.range?.end ?? ''
        },
        totals: {
            quantity: n(dto?.totals?.quantity),
            grossSales: n(dto?.totals?.gross_sales),
            discounts: n(dto?.totals?.discounts),
            refunds: n(dto?.totals?.refunds),
            netSales: n(dto?.totals?.net_sales),
            allNetSales: n(dto?.totals?.all_net_sales)
        },
        meta: {
            page: n(dto?.meta?.page) || 1,
            perPage: n(dto?.meta?.per_page) || 10,
            totalCount: n(dto?.meta?.total_count),
            totalPages: n(dto?.meta?.total_pages) || 1
        },
        products: (dto?.products ?? []).map(p => ({
            businessProductId: p.business_product_id ?? '—',
            productName: p.product_name ?? '—',
            brand: p.brand ?? '—',
            category: p.category ?? '—',

            quantity: n(p.quantity),
            avgPrice: n(p.avg_price),
            grossSales: n(p.gross_sales),
            discounts: n(p.discounts),
            refunds: n(p.refunds),
            netSales: n(p.net_sales),

            netProductSalesPct: n(p.net_product_sales_pct),
            allNetSalesPct: n(p.all_net_sales_pct)
        }))
    };
};
